import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';

export const getRealtorById = async (id: string) => {
  try {
    const response = await axios.get(`${API_URL}/realtor/get-by-id/${id}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};

export const getTeamMembersByLeaderId = async (leaderId: string, token: string) => {
  try {
    const response = await axios.get(`${API_URL}/realtor/team-members/${leaderId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error: any) {
    console.error("Error en getTeamMembersByLeaderId:", error)
    handleAuthError(error)
    return undefined
  }
}

export const getAllRealtors = async (token: string) => {
  try {
    const response = await axios.get(`${API_URL}/realtor/realtors`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error: any) {
    console.error("Error en getAllRealtors:", error)
    handleAuthError(error)
    return undefined
  }
}

export const fetchAllRealtors = async() => {
const response = await axios.get(`${API_URL}/Realtor/get-all`);

if(response.status === 200){
  return response.data;
}
}


const handleAuthError = (error: any) => {
    if (error.response) {
      throw new Error(error.response.data.message || error.message); 
    } else {
      throw new Error(error.message || 'An unknown error occurred');
    }
  };